import type { GridColDef } from '@mui/x-data-grid-pro'

import type { ListColumnSetting } from './use-list-service/types'

export interface ColumnWidths {
  [field: string]: number | undefined
}

const defaultColumnWidth = 200

export function mapListSettingsToColumnWidths(settings: ListColumnSetting[]): ColumnWidths {
  return settings.reduce<ColumnWidths>((columnWidths, setting) => {
    columnWidths[setting.Name] = setting.Width

    return columnWidths
  }, {})
}

export function mapColumnsToColumnWidths(columns: GridColDef[]): ColumnWidths {
  return columns.reduce<ColumnWidths>((columnWidths, column) => {
    columnWidths[column.field] = column.width

    return columnWidths
  }, {})
}

export function queryColumnWidth(columnWidths: ColumnWidths, field: string): number {
  return columnWidths[field] ?? defaultColumnWidth
}
